export default "__VITE_ASSET__DKALIr7i__"